export default __webpack_public_path__ + "static/night-e935fdd1e4c7b60db8b1dfe4b41927dd.webp";